import React from 'react';

const CONTACT_US_URL = 'https://myyogateacher.com/contactus';

// PDF-only closing card — https://www.figma.com/design/tEh3nGLKULPHQ3KgQFSciK/Personalised-Plan?node-id=4858-248
const GetInTouch: React.FC = () => (
  <div className="w-full flex justify-center mt-[25px]">
    <div
      data-pdf-section
      data-pdf-force-page-break
      className="w-full bg-[#F9F9F9] rounded-[20px] py-[50px] px-[40px] flex flex-col items-center gap-[24px]"
    >
      <p className="text-center text-[22px] leading-[28px] font-Inter font-[550] m-0">
        <span className="text-[#232323]">Still have Questions? </span>
        <br />
        <span className="text-[#EE731B]">Get in touch</span>
      </p>
      <a
        href={CONTACT_US_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-pdf-cta-link
        className="flex items-center justify-center text-center bg-[#EE731B] rounded-[10px] px-[20px] pb-[20px] text-white text-[13px] font-Inter font-[550] leading-[16px] shadow-[0px_2px_4px_0px_rgba(248,102,36,0.15)] no-underline"
      >
        Speak to the team
      </a>
    </div>
  </div>
);

export default GetInTouch;
